import { post } from '../Services/http';
import { catchError } from './Error.action';
import { AFIILIATE_LOAD_ERROR, AFFILIATE_RECEIVE } from '../bevegoConstants';

export const loadError = (error) => ({
    type: AFIILIATE_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (affiliates) => ({
    type: AFFILIATE_RECEIVE,
    payload: affiliates
});

export const changeAffiliate = (affiliatesId) => (dispatch) => {
    return post('/api/affiliate', affiliatesId)
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const contactAffiliate = (affiliateId, articleNumber) => (dispatch) => {
    return post('/api/affiliate/contact', {articleNumber, affiliateId})
};

export const updateCurrentStockBalances = (selectedAffiliateId, articlesToFetch) => (dispatch) => {
    return post('/api/affiliateStock', {selectedAffiliateId, articlesToFetch})
        .then((response) => response.json())
        .then((result) => {
            var stockBalances = document.querySelectorAll('[data-stockvariantid]');
            stockBalances.forEach((element, index) => {
                // Create a temporary DOM to extract the content
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = result[index];
                const container = tempDiv.querySelector('.product-detail__stock-status-container');
                if (container) {
                    element.innerHTML = container.innerHTML;
                }
            });
        })
}
